export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14003.be00acdf.jpg";